import { Marker } from "@adamscybot/react-leaflet-component-marker";
import { memo } from "react";
import { Z_INDEX_OFFSETS } from "../constants";
import { ClusterMapItem, DeviceMapItem } from "../types";
import { DeviceGroupMapEntityIcon } from "./device-group-map-entity-icon";

interface ClusterMarkerProps {
    clusterMapItem: ClusterMapItem;
    deviceItems: DeviceMapItem[];
    isHovered: boolean;
    mapComponent: L.Map;
    onIconHover: (id: string | null) => void;
    hidden?: boolean;
    dimmed?: boolean;
}

export const ClusterMarkerMemo = memo(
    ({ clusterMapItem, deviceItems, isHovered, mapComponent, onIconHover, hidden, dimmed }: ClusterMarkerProps) => (
        <Marker
            key={clusterMapItem.id}
            position={[clusterMapItem.lat, clusterMapItem.long]}
            zIndexOffset={isHovered ? Z_INDEX_OFFSETS.ICON_HOVERED : 0}
            icon={
                <DeviceGroupMapEntityIcon
                    key={clusterMapItem.id}
                    clusterMapItem={clusterMapItem}
                    allDeviceMapItems={deviceItems}
                    mapComponent={mapComponent}
                    onHover={(isHovering) => onIconHover(isHovering ? clusterMapItem.id : null)}
                    hidden={hidden}
                    dimmed={dimmed}
                />
            }
        />
    ),
    (prevProps, nextProps) =>
        // Custom comparison to prevent unnecessary re-renders
        prevProps.clusterMapItem.id === nextProps.clusterMapItem.id &&
        prevProps.isHovered === nextProps.isHovered &&
        prevProps.hidden === nextProps.hidden &&
        prevProps.dimmed === nextProps.dimmed &&
        prevProps.deviceItems.length === nextProps.deviceItems.length,
);
